import PostListView from './post-list-view'

export default PostListView
